module.exports = "<div class=\"alert-danger error-description\" [formGroup]=\"formGroup\" *ngIf=\"shouldShowErrors()\">\r\n  <div *ngFor=\"let error of listOfErrors()\">{{error}}</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/validation-alert/validation-alert.component.html
// module id = ../../../../../src/app/widgets/validation-alert/validation-alert.component.html
// module chunks = main